// primary
export const yellow = '#EFCD33';
export const blue = '#0064AF';
export const backgroundBlue = '#00b0ff29';
export const green = '#36996A';
export const pink = '#BA007C';
export const orange = '#FBB034';
export const red = '#F34242';
export const white = '#FFFFFF';
export const shadedWhite = '#EBEBED';
export const backgroundWhite = '#FDFDFD';
export const black = '#0E0E0E';
export const deepBlack = '#000000DE';
export const autoSkyBlue = '#2494F2';
export const transparent = '#ffffff00';
export const passwordBlue = '#4285f3';
export const messageGreen = '#80c178';
export const iconYellow = '#F2C533';

export const navSuperAdmin = '#424242';
export const navAdmin = '#0018EE';
export const navOperator = '#00B0FF';
// navCompanyContext uses the color palette.deepBlue

export const navSuperAdminActions = '#000A62';
export const navAdminActions = '#0018EE';
export const navOperatorActions = '#00B0FF';
export const navCompanyContextActions = '#000A62';

export const lightNavSuperAdminActions = '#EEEEEE';
export const lightNavAdminActions = '#e9f4f0';
export const lightNavOperatorActions = '#ebf0fd';
export const lightNavCompanyContextActions = '#EEEEEE';

// gray scale
export const superLightGray = '#FAFAFA';
export const greyCardBorder = '#e3e3e3';
export const lightGray = '#EDEDED';
export const gray = '#707070';
export const sideGray = '#a6a8a3';
export const sideGrayLighter = '#a6a8a3ab';
export const darkGray = '#515350';
export const darkerGray = '#474845';
export const strongGray = '#8d8d8d';
export const borderGray = '#D9D9D9';
export const lightShadow = '#0000001f';
export const mediumShadow = '#00000024';
export const darkShadow = '#00000033';
export const insideFormGray = '#00000099';

// dashboard
export const dashYellow = '#EDC240';
export const dashRed = '#CB4B4B';
export const dashGreen = '#4DA74D';
export const dashLightYellow = '#FFCC57';
export const dashTurquoise = '#4CC0C0';
export const dashBlue = '#36A2EB';
export const dashPink = '#D64865';
export const dashLightPink = '#FF6484';

// status
export const success = '#10c978';
export const error = red;
export const waiting = orange;
export const validating = yellow;
export const approved = green;
export const invalid = darkGray;

export const lightGreen = '#dcedc8';
export const lightYellow = '#fdf5c4';
export const lightRed = '#ffcccb';

export const superLightYellow = '#FFFFE6';
export const superLightGreen = '#dcedc8ab';
export const superLightRed = '#ffcccb8c';
export const backgroundSuperLightRed = '#ce11260d';

export const backgroundLightGreen = '#dcedc86b';
export const backgroundLightRed = '#ffcccb4f';

export const checkedLightYellow = '#ffffcb';

export const darkGreen = '#04542c';
export const darkYellow = '#9b870c';
export const darkRed = '#800000';

export const superDarkYellow = '#7a6c15';

// rebranding
export const deepBlue = '#000A62';
export const digitalBlue = '#0018EE';
export const offWhite = '#FAFAFA';
export const limeGreen = '#DEFE52';
export const lightBlue = '#00B0FF';
export const pinkAccent = '#FF5EC4';
export const blackC = '#000000';
export const grey900 = '#212121';
export const grey800 = '#424242';
export const grey700 = '#616161';
export const grey600 = '#757575';
export const grey500 = '#9E9E9E';
export const grey400 = '#BDBDBD';
export const grey300 = '#E0E0E0';
export const grey200 = '#EEEEEE';

// light rebrand colors
export const lightDeepBlue = '#000a625f';
export const superLightDeepBlue = '#000a6214';
export const lightDigitalBlue = '#0018ee50';
export const lightLimeGreen = '#defe5267';
export const lightLightBlue = 'rgba(0, 174, 255, 0.325)';
export const lightPinkAccent = '#ff5ec46f';
export const lightGrey800 = '#4242425b';
export const lightGrey400 = '#9e9e9e3a';

// Color variants for graphs
export const deepBlueLight1 = '#1A1E75';
export const deepBlueLight2 = '#343688';
export const deepBlueLight3 = '#4E509B';
export const deepBlueDark1 = '#000851';
export const deepBlueDark2 = '#000740';
export const deepBlueDark3 = '#00062F';
export const deepBlueDark4 = '#00051E';

export const digitalBlueLight1 = '#334CF0';
export const digitalBlueLight2 = '#667FF2';
export const digitalBlueLight3 = '#99B3F4';
export const digitalBlueDark1 = '#0015D6';
export const digitalBlueDark2 = '#0012BE';
export const digitalBlueDark3 = '#000FA6';
export const digitalBlueDark4 = '#000C8E';

export const lightBlueLight1 = '#33BFFF';
export const lightBlueLight2 = '#66CFFF';
export const lightBlueLight3 = '#99DFFF';
export const lightBlueDark1 = '#00A0E5';
export const lightBlueDark2 = '#0090CC';
export const lightBlueDark3 = '#0080B2';
export const lightBlueDark4 = '#007099';

// Logs
export const logsLightGreen = '#dcedc838';
export const logsLightGray = '#eeeeeeba';
export const logsLightRed = '#ce11260d';
export const logsLightBlue = '#ebf0fd8c';
export const logsLightYellow = '#fffce6a3';
export const logsBlue = '#0064af54';
export const logsGreen = '#cfe7b4';
export const logsGray = '#a6a8a3';

// sky.one
export const skyOne = {
  integra: '#CB613F',
  simple: '#009BDB',
};
